// extracted by mini-css-extract-plugin
export default {"select_wrapper":"SelectMark_select_wrapper__TNeyq","readonly":"SelectMark_readonly__zU3d7","not_allowed":"SelectMark_not_allowed__WE-zO"};